import {combineReducers} from 'redux';
import {routerReducer} from 'react-router-redux';

import appReducer from './app';
import apiKeyReducer from './apiKey';

export default combineReducers({
    routing: routerReducer,
    app: appReducer,
    apiKeyState: apiKeyReducer,
});
